<dv-dialog-content>
  <dv-form-wrapper>
    <dv-form [formGroup]="formGroup" [elements]="elements"></dv-form>
  </dv-form-wrapper>
  <dv-button footer-right (click)="onCancel()">
    {{ 'Button.Cancel' | translate }}
  </dv-button>
  <dv-button footer-right color="secondary" (click)="onConfirm(formGroup.controls.text.value)">
    {{ 'Button.Save' | translate }}
  </dv-button>
</dv-dialog-content>
